module.exports = __webpack_public_path__ + "static/img/101.c20c862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/101.jpg
// module id = Ul0R
// module chunks = 2